<template>
    <div>
        <!-- 搜索 -->
        <div class="topSearch">
            <div class="searchWrap">
                <!--搜索 版的切换-->
                <div class="searchEditionBox">
                    <div v-for="(item,index) in editionList" :key="index">
                        <div 
                            class="editionList" 
                            :class="searchEditionIndex==index?'editionListCheck':''"
                            @click="searchEditionClick(item,index)">
                            <span>{{ item.name }}</span>
                        </div>
                    </div>
                </div>
                <div class="topBorder"></div>
                <!--搜索 版的展示-->
                <div class="searchInputBox" v-if="searchEditionIndex ==1||searchEditionIndex==0">
                    <div class="leftTypeName">
                        <img :class="editionList[searchEditionIndex].type=='jichaanli'?'jcalIMG':''" :src="editionList[searchEditionIndex].img" alt="">
                    </div>
                    <div class="rightInputBox">
                        <div class="inputTopType">
                            <div 
                                class="inputTopTypeList"
                                v-for="(item,index) in searchTypeList"
                                @click="searchTypeClick(item,index)" 
                                :key="index">
                                <div class="inputTopTypeName" :class="searchTypeIndex == index?'inputTopCheck':''">
                                    {{ item.name }}
                                </div>
                                <div v-show="searchTypeIndex==index" class="inputTopTypeBorder"></div>
                            </div>
                        </div>
                        <div class="inputBottom">
                            <div class="inputSearchLeft" v-if="searchTypeIndex==0||searchTypeIndex==1">
                                <el-input v-model="inputValue" clearable placeholder="请输入要搜索的关键词，两个以上关键词用空格分开"></el-input>
                            </div>
                            <div class="inputSearchLeft" v-if="searchTypeIndex==2">
                                <div class="iLeft">
                                    <span>{</span>
                                    <div class="iLeftWrap">
                                        <el-input v-model="inputW" clearable placeholder="2022" :maxlength="5"></el-input>
                                    </div>
                                    <span>}</span>
                                    <span class="nian">年</span>
                                </div>
                                <div class="iRight">
                                    <div class="iRightWrap">
                                        <el-input v-model="inputH" clearable placeholder="22" :maxlength="4"></el-input>
                                    </div>
                                    <span>号</span>
                                </div>
                            </div>
                            <div class="inputSearchLeft"  v-if="searchTypeIndex==3">
                                <div>
                                    <p class="timeP" @click="openTimeList" v-if="inputTime===''">请点击搜索框进行年份选择</p>
                                    <p class="timeP" v-else>{{ inputTime }}</p>
                                    <div v-if="inputTime!==''" @click="clearTimeClick" class="clearTime">×</div>
                                </div>
                            </div>
                            <div class="inputSearchBtn" @click="searchClick">搜索</div>
                            <div  class="searchHome" @click="goHome()" v-if="$route.path !='/index'">
                                <span
                                    style="
                                        font-size: 20px;
                                        line-height: 60px;
                                        color: #0f59a4;
                                        font-weight: 700;
                                        cursor: pointer;
                                "
                                >
                                <i class="el-icon-s-home" style="margin-right: 8px"></i>
                                <span>首页</span>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="searchInputBoxQT" v-if="searchEditionIndex !=0&&searchEditionIndex!=1">
                    <div class="leftTypeName">
                        <img :class="editionList[searchEditionIndex].type=='jichaanli'?'jcalIMG':''" :src="editionList[searchEditionIndex].img" alt="">
                    </div>
                    <div class="rightInputBox">
                        <div class="inputBottom">
                            <div class="inputSearchLeft">
                                <el-input v-model="inputValue" clearable placeholder="请输入要搜索的关键词，两个以上关键词用空格分开"></el-input>
                            </div>
                            <div class="inputSearchBtn" @click="searchClick">搜索</div>
                            <div  class="searchHome" @click="goHome()" v-if="$route.path !='/index'">
                                <span
                                    style="
                                        font-size: 20px;
                                        line-height: 60px;
                                        color: #0f59a4;
                                        font-weight: 700;
                                        cursor: pointer;
                                "
                                >
                                <i class="el-icon-s-home" style="margin-right: 8px"></i>
                                <span>首页</span>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <el-dialog
            title="时间轴"
            class="timeDialog"
            :visible.sync="dialogVisible"
            width="30%"
            :before-close="handleClose">
            <div 
                :class="inputTime == item?'timeListCheck':''"
                class="timeList"
                v-for="(item,index) in timeList" :key="index"
                @click="checkTime(item)">
                {{ item }}
            </div>
        </el-dialog>
    </div>
</template>
<script>

import { editionList,typeList } from "@/config/searchEdition.js"


export default {
    name:'',
    data(){
        return{
            dialogVisible:false,
            //输入框绑定值
            inputValue:'',
            //文号
            inputW:'',
            inputH:'',
            timeList:[
                '2024年','2023年','2022年','2021年','2020年','2019年','2018年','2017年',
                '2016年','2015年','2014年','2013年','2012年','2011年','2010年','2009年',
                '2008年','2007年','2006年','2005年'
                
            ],
            //时间
            inputTime:'',
            startPublicDate:'',
            endPublicDate:'',
            //搜索版的选中
            searchEditionIndex:0,
            //搜索版的列表
            editionList:editionList,
            //搜索下的检索类型选中
            searchTypeIndex:0,
            searchTypeIndexOld:0,
            //搜索下的检索类型
            searchTypeList:typeList,
        }
    },
    mounted(){
        //顶部分类的index
        if(this.$route.path == '/searchZY'){
            this.searchEditionIndex = 1;
        }
        if(this.$route.path == '/searchSG'){
            this.searchEditionIndex = 2;
        }
        if(this.$route.path == '/searchKJ'){
            this.searchEditionIndex = 3;
        }
        if(this.$route.path == '/searchHY'){
            this.searchEditionIndex = 4;
        }
        if(this.$route.path == '/searchDY'){
            this.searchEditionIndex = 5;
        }
        if(this.$route.path == '/searchJCAL'){
            this.searchEditionIndex = 6;
        }

        //有传递的参数时的回显
        if(this.$route.params.inputValue){
            //初始赋值
            this.startData(this.$route.params)
        }
    },
    methods:{
        //初始赋值
        startData(data){
            this.searchTypeIndex = data.searchType;
            this.inputValue = data.inputValue;
            this.startPublicDate = data.startPublicDate;
            this.endPublicDate = data.endPublicDate;
            if(this.searchTypeIndex == 3){
                this.inputTime = this.startPublicDate.slice(0,4) + '年';
            }
            if(this.searchTypeIndex == 2){
                let newArr = data.inputValue.split(' ');
                this.inputW = newArr[0];
                this.inputH = newArr[1]?newArr[1]:'';
            }
        },
        //回首页
        goHome(){
            this.$router.push('/')
            //跨组件通讯
            //EventBus.$emit('dataForOtherRoute', {path:''});
        },
        //搜索版的切换
        searchEditionClick(item,index){
            //是否是除了普适版和专业版的其他版
            if(index != 0&&index != 1){
                //获取会员及登录信息
                let tUser = sessionStorage.getItem("userInfoData");
                tUser = JSON.parse(tUser)
                //console.log(tUser)
                if(!tUser.id){
                    this.$message({
                        message:'请您先登录后查看!',
                        type:'warning'
                    })
                    return
                    //回到首页
                    //this.$router.push('/')
                }else{
                    //是否是会员
                    if(tUser.vipInfo&&tUser.vipInfo.isVip&&tUser.vipInfo.isVip==1){
                        console.log(tUser)
                    }else{
                        this.$message({
                            message:'请您购买会员后查看!',
                            type:'warning'
                        })
                        return
                        //回到首页
                        //this.$router.push('/')
                    }
                }
            }
            
            if(index == this.searchEditionIndexS){
                return
            }

             //专业版 普适版 切换进入其他几个类型的
             if(item.type!='putong'&&item.type!='zhuanye'){
                this.searchTypeIndexOld = this.searchTypeIndex;
                this.searchTypeIndex = 0;
                this.inputValue = '';
            }
            //专业版 普适版 从其他几个类型切换进来的
            if((item.type=='putong'&&this.searchEditionIndex!=1)||(item.type=='zhuanye'&&this.searchEditionIndex!=0)){
                this.searchTypeIndex = this.searchTypeIndexOld;
            }
            //console.log(item)
            this.searchEditionIndex = index;

            this.searchClick();
           
        },
        //搜索下的类型切换
        searchTypeClick(item,index){
            this.searchTypeIndex = index
        },
        //打开时间选择
        openTimeList(){
            this.dialogVisible = true;
        },
        //选择时间
        checkTime(item){
            this.inputTime = item;
            this.dialogVisible = false;
        },
        clearTimeClick(){
            this.inputTime = '';
        },
        handleClose(){
            this.dialogVisible = false;
        },
        //搜索点击事件
        searchClick(){
            if(this.searchTypeIndex == 2){
                this.inputValue = this.inputW.trim() + ' ' +  this.inputH.trim();
            }
            if(this.searchTypeIndex == 3){
                if(this.inputTime!=''){
                    let newText = this.inputTime.slice(0,this.inputTime.length-1)
                    this.startPublicDate = newText + '-01-01'
                    this.endPublicDate = newText + '-12-31'
                }else{
                    this.startPublicDate = ''
                    this.endPublicDate = ''
                }
            }

            /***
             * 传递的参数
             * 
             * searchType -- 查询的分类 0-查全文-content 1-查标题-title 2-查文号-articleNo 3-查时间 
             * inputValue  -- 传递的关键字 (是0,1,2分类的)
             * startPublicDate  -- 开始时间(3-查时间)
             * endPublicDate    -- 结束时间(3-查时间)
             * searchKeyName    -- 查询的分类的关键字
             * 
             */
            let newObj = {
                searchType:this.searchTypeIndex,
                inputValue:this.inputValue,
                startPublicDate:this.startPublicDate,
                endPublicDate:this.endPublicDate,
                searchKeyName:this.searchTypeIndex==0?'content':this.searchTypeIndex==1?'title':this.searchTypeIndex==2?'articleNo':''
            }

            //获取当前路由 判断路由 是否是搜索页面 是搜索页面直接搜索 不是则跳转搜索页面
            let itemPathName =  this.editionList[this.searchEditionIndex].pathName;
            //是不是当前路由 不是 就跳转路由 是就传递搜索参数
            if(this.$route.name != itemPathName){
                this.$router.push({
                    name:itemPathName,
                    params:newObj
                })
            }else{
                // 触发搜索传递给父级页面
                this.$emit('topSearchParentReceive',newObj)
            }
        }
    },
    
}
</script>
<style lang="scss" scoped>
/***搜索框 start */
.topSearch{
    width:100%;
    min-height:195px;
    padding-top:40px;
    background: #F3F8FC;
    box-sizing: border-box;
    .searchWrap{
        width: 1200px;
        margin: 0 auto;
        min-height: 155px;
        .searchEditionBox{
            width:100%;
            height:40px;
            overflow: hidden;
            box-sizing: border-box;
            // padding-left:90px;
            padding-left:185px;
            .editionList{
                min-width:130px;
                height:40px;
                line-height:38px;
                text-align:center;
                font-size: 20px;
                font-weight: 400;
                color: #0F59A4;
                float:left;
                border: 1px solid #DCDCDC;
                box-sizing: border-box;
                background: #FFFFFF;
                cursor:pointer;
                margin-right:10px;
                -webkit-user-select: none;
            }
            .editionListCheck{
                background: #0F59A4!important;
                color:#ffffff!important;
                font-weight: 700;
                border: 1px solid #0F59A4!important;
            }
        }
        .topBorder{
            width:100%;
            height:4px;
            background: #0F59A4;
        }
        .searchInputBox{
            width:100%;
            height:151px;
            box-sizing: border-box;
            background: #FFFFFF;
            border-left: 2px solid #DCDCDC;
            border-right: 2px solid #DCDCDC;
            border-bottom: 2px solid #DCDCDC;
            .leftTypeName{
                width:285px;
                float:left;
                box-sizing: border-box;
                padding-top:80px;
                padding-right:34px;
                .jcalIMG{
                    width: 230px!important;
                    height: 30px;
                }
                img{
                    width: 166px;
                    height: 30px;
                    float:right;
                }
            }
            .rightInputBox{
                width:calc(100% - 285px);
                float:left;
                .inputTopType{
                    width:100%;
                    height:66px;
                    box-sizing: border-box;
                    padding-top:25px;
                    padding-left:68px;
                    .inputTopTypeList{
                        width:75px;
                        height:30px;
                        line-height:20px;
                        margin: 0 27px;
                        overflow: hidden;
                        float:left;
                        text-align: center;
                        cursor:pointer;
                        -webkit-user-select: none;
                        .inputTopCheck{
                            font-weight: 700;
                            color:#0F59A4!important;
                        }
                        .inputTopTypeName{
                            font-size: 18px;
                            color:#3D3D3D;
                        }
                        .inputTopTypeBorder{
                            width:100%;
                            height:4px;
                            margin-top:5px;
                            background: #0F59A4;
                            border-radius: 2px 2px 2px 2px;
                        }
                    }
                }
                .inputBottom{
                    width:100%;
                    height:60px;
                    box-sizing: border-box;
                    padding-right:165px;
                    position: relative;
                    .inputSearchLeft{
                        width:calc(100% - 150px);
                        height: 60px;
                        float:left;
                        box-sizing: border-box;
                        border: 2px solid #0F59A4;
                        position: relative;
                        ::v-deep .el-input__inner{
                            height:56px;
                            border:none;
                        }
                        .clearTime{
                            width:20px;
                            height:20px;
                            line-height: 20px;
                            text-align: center;
                            border:1px solid #DCDCDC;
                            position: absolute;
                            top:15px;
                            right:15px;
                            border-radius:50%;
                            cursor: pointer;
                        }
                        .timeP{
                            line-height: 56px;
                            color: #606266;
                            font-size: 14px;
                            padding-left:15px;
                        }
                        .iLeft{
                            width:calc(55%);
                            height: 60px;
                            float:left;
                            padding-left:100px;
                            box-sizing: border-box;
                            .iLeftWrap{
                                display: inline-block;
                            }
                            .nian{
                                margin-left:50px;
                            }
                            ::v-deep .el-input__inner{
                                width:100px;
                                padding: 0;
                                text-align: center;
                            }
                        }
                        .iRight{
                            width:calc(45%);
                            height: 80px;
                            float:left;
                            .iRightWrap{
                                display: inline-block;
                            }
                            ::v-deep .el-input__inner{
                                width:100px;
                                padding: 0;
                                text-align: center;
                            }
                        }
                    }
                    .inputSearchBtn{
                        width: 150px;
                        height: 60px;
                        line-height: 60px;
                        text-align: center;
                        background: #105AA5;
                        float:left;
                        border-radius: 0px 0px 0px 0px;
                        font-weight: 700;
                        font-size: 18px;
                        color: #FFFFFF;
                        letter-spacing: 18px;
                        box-sizing: border-box;
                        padding-left:18px;
                        -webkit-user-select: none;
                        cursor:pointer;
                    }
                    .searchHome{
                        width:100px;
                        height:60px;
                        position: absolute;
                        right:35px;
                        top:0;
                    }
                }
            }
        }
        .searchInputBoxQT{
            width:100%;
            height:111px;
            box-sizing: border-box;
            background: #FFFFFF;
            border-left: 2px solid #DCDCDC;
            border-right: 2px solid #DCDCDC;
            border-bottom: 2px solid #DCDCDC;
            .leftTypeName{
                width:285px;
                float:left;
                box-sizing: border-box;
                padding-top:44px;
                padding-right:34px;
                .jcalIMG{
                    width: 230px!important;
                    height: 30px;
                }
                img{
                    width: 166px;
                    height: 30px;
                    float:right;
                }
            }
            .rightInputBox{
                width:calc(100% - 285px);
                float:left;
                margin-top:30px;
                .inputBottom{
                    width:100%;
                    height:60px;
                    box-sizing: border-box;
                    padding-right:165px;
                    position: relative;
                    .inputSearchLeft{
                        width:calc(100% - 150px);
                        height: 60px;
                        float:left;
                        box-sizing: border-box;
                        border: 2px solid #0F59A4;
                        position: relative;
                        ::v-deep .el-input__inner{
                            height:56px;
                            border:none;
                        }
                        .iRight{
                            width:calc(45%);
                            height: 80px;
                            float:left;
                            .iRightWrap{
                                display: inline-block;
                            }
                            ::v-deep .el-input__inner{
                                width:100px;
                                padding: 0;
                                text-align: center;
                            }
                        }
                    }
                    .inputSearchBtn{
                        width: 150px;
                        height: 60px;
                        line-height: 60px;
                        text-align: center;
                        background: #105AA5;
                        float:left;
                        border-radius: 0px 0px 0px 0px;
                        font-weight: 700;
                        font-size: 18px;
                        color: #FFFFFF;
                        letter-spacing: 18px;
                        box-sizing: border-box;
                        padding-left:18px;
                        -webkit-user-select: none;
                        cursor:pointer;
                    }
                    .searchHome{
                        width:100px;
                        height:60px;
                        position: absolute;
                        right:35px;
                        top:0;
                    }
                }
            }
        }
    }
}

/***搜索框 end */

.timeDialog ::v-deep .el-dialog__header{
    text-align: center;
}
.timeDialog ::v-deep .el-dialog__body{
    overflow: hidden;
}
.timeListCheck{
    background: #2656b8 !important;
    color: #fff !important;
}
.timeList{
    width:110px;
    text-align: center;
    height: 40px;
    line-height: 40px;
    float:left;
    background: #f2f7fd;
    border-radius: 8px;
    font-weight: 400;
    color: #333333;
    margin:0 10px 15px 10px;
    cursor:pointer;
}
</style>
